module.exports = __webpack_public_path__ + "static/media/diktat-16.d3d337dd.mp3";